import { ConstructorTabs } from "../../../components/admin-console/constructor-tabs";
import { MOCK_CONSTRUCTOR_SERVICES } from "../../constructor-services-page/constructor-services-page.lib";
import { useConstructorRoads } from "../hooks/use-constructor-roads";

/** Табы «Конструктор — Услуги / Дороги / Документы» со счётчиками из данных. */
export const ConstructorRoadsTabs = () => {
  const { roads } = useConstructorRoads();

  return <ConstructorTabs servicesCount={MOCK_CONSTRUCTOR_SERVICES.length} roadsCount={roads.length} />;
};
